<template>
  <Category cate-name="safety" category-name="安全・防災" />
</template>

<script>
import Category from '@/components/Category.vue'
export default {
  components: {
    Category
  }
}
</script>

<style scoped></style>
